import React, { useEffect, useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { CHANNEL_API } from '../api/channel/index';
import { ApiContext } from '../context/api/apiContext';
import { AuthContext } from '../context/auth/authContext';
import history from '../history';

import Artist from '../components/Artist/Artist';
import HeroBg from '../i/bg_section_2.jpg';
import Spinner from '../components/Spinner/Spinner';
import HowStreamInWorks from '../components/Sections/HowStreamInWorks';

export const MyStreams = () => {
	const { loading, events, fetchEvents, loadEventsPage } = useContext(ApiContext);
	const [currentEventsPage, setCurrentEventsPage] = useState(1);
	const [showLoadError, setShowLoadError] = useState(false);
	const [isEventsLoading, setEventsLoading] = useState(false);
	const [loadMoreBtn, showLoadMoreBtn] = useState(false);

	const handleOnClick = id => {
		history.push(`/edit-stream/${id}`);
	};

	const loadEvents = async () => {
		const events = await fetchEvents();

		const res = await loadEventsPage(2, true);

		if (res) {
			showLoadMoreBtn(res);
		}

	};

	const loadMoreEvents = async () => {
		try {
			setEventsLoading(true);
			const res = await loadEventsPage(currentEventsPage + 1);

			if (res) {
				setCurrentEventsPage(currentEventsPage + 1);
				setEventsLoading(false);
			} else {
				setEventsLoading(true);
				setShowLoadError(true);
			}
		} catch (e) {
			throw new Error(e.message);
		}

	};

	useEffect(() => {
		loadEvents();
	}, []);

	return (
		<React.Fragment>
			<section className="section hero_v3_mod center_level_mod bottom_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${HeroBg})` }} />
				<div className="section_in">
					<h2 className="section_title center_level_mod hero_v1_mod">MY STREAMS</h2>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<div className="artist_list_w">
						{!loading ? (
							(events && events.length) ? (
								<div className="artist_list">
									{
										events.map(({ id, artist, title, day, base_url, img }) => {
											return (
												<div className="artist_list_item" key={id}>
													<Artist
														path='/'
														img={base_url + img}
														channel={artist}
														artist={title}
														day={day}
														editBtn
														handleOnClick={() => handleOnClick(id)}
													/>
												</div>
											);
										})
									}
								</div>
							) : (
									<div className="search_result_note">There are no events.</div>
								)
						) : (
								<Spinner darkMod />
							)}
					</div>
					<div className="btn_w center_level_mod limit_mod">
						{loadMoreBtn ? (
							<button
								className="btn_download offset_mod"
								onClick={loadMoreEvents}
								disabled={loading || isEventsLoading}
							>
								{!showLoadError ? 'Load more' : 'No more events'}
							</button>
						) : null}
						<NavLink
							className={`btn_stream ${isEventsLoading ? 'disabled_mod' : ''}`}
							to="/create-stream"
						>Create Stream</NavLink>
					</div>
				</div>
			</section>
			<HowStreamInWorks />
		</React.Fragment>
	);
}
export default MyStreams;